module.exports = __webpack_public_path__ + "static/media/error.c2782ec4.png";